import React, { useState } from 'react';
import breakup from '../assets/zodiacimage/breakuptarot.jpg';
import CommonNavbar from './CommonNavbar';
import Footer from '../home/Footer';
import Queryform from './Queryform';
import chariot from "../assets/alltarotcards/chariot.jpg";
import death from "../assets/alltarotcards/death.jpg";
import emperor from "../assets/alltarotcards/emperor.jpg";
import hangedman from "../assets/alltarotcards/hangedMan.jpg";
import hermit from "../assets/alltarotcards/hermit.jpg";
import hieropant from "../assets/alltarotcards/hieropant.jpg";
import justice from "../assets/alltarotcards/justice.jpg";
import lover from "../assets/alltarotcards/lovers.jpg";
import moon from "../assets/alltarotcards/moon.jpg";
import priestess from "../assets/alltarotcards/priestess.jpg";
import star from "../assets/alltarotcards/star.jpg";
import sun from "../assets/alltarotcards/sun.jpg";
import temperance from "../assets/alltarotcards/temperance.jpg";
import tower from "../assets/alltarotcards/tower.jpg";
import wheelfortune from "../assets/alltarotcards/wheelFortune.jpg";
import world from "../assets/alltarotcards/world.jpg";
import dailyHoroscope from "../assets/rootimg/kundlicomp.png";
import rings from "../assets/rootimg/two-rings.png";
import compatibility from "../assets/rootimg/compatibility.png";
import { Link, useNavigate } from 'react-router';
import Navbar from '../home/Navbar';

const BreakupTarot = () => {
    const [IsActive1, setIsActive1] = useState(false);
    const [IsActive2, setIsActive2] = useState(false);
    const [pickedCard1, setPickedCard1] = useState(null);
    const [pickedCard2, setPickedCard2] = useState(null);
    const [isFirstCardClicked, setIsFirstCardClicked] = useState(false); // Track if the first card has been clicked
    const [isSecondCardClicked, setIsSecondCardClicked] = useState(false); // Track if the second card has been clicked

    const navigate = useNavigate();
    const kundliClick = (e) => {
        e.preventDefault();
        navigate('/kundlimatching');
    }
    const horoscopeClick = (e) => {
        e.preventDefault();
        navigate('/horoscope');
    }
    const compatibilityClick = (e) => {
        e.preventDefault();
        navigate('/compatibility');
    }
    const getRandomCard = () => {
        const cardsImage = [
            { alt: 'chariot', pic: chariot },
            { alt: 'death', pic: death },
            { alt: 'emperor', pic: emperor },
            { alt: 'hangedman', pic: hangedman },
            { alt: 'hermit', pic: hermit },
            { alt: 'hieropant', pic: hieropant },
            { alt: 'justice', pic: justice },
            { alt: 'lover', pic: lover },
            { alt: 'moon', pic: moon },
            { alt: 'priestess', pic: priestess },
            { alt: 'star', pic: star },
            { alt: 'sun', pic: sun },
            { alt: 'temperance', pic: temperance },
            { alt: 'tower', pic: tower },
            { alt: 'wheelfortune', pic: wheelfortune },
            { alt: 'world', pic: world },
        ];
        return cardsImage[Math.floor(Math.random() * cardsImage.length)];
    };

    const firstCardClick = () => {
        if (isFirstCardClicked) return; // Prevent further clicks after first click
        setIsActive1(true);
        const randomCard = getRandomCard();
        setPickedCard1(randomCard.pic); // store the picked card
        setIsFirstCardClicked(true); // Mark the first card as clicked
    };

    const secondCardClick = () => {
        if (isSecondCardClicked) return; // Prevent further clicks after first click
        setIsActive2(true);
        const randomCard = getRandomCard();
        setPickedCard2(randomCard.pic); // store the picked card
        setIsSecondCardClicked(true); // Mark the second card as clicked
    };

    return (
        <>
            <section className='container mx-auto bg-gradient-to-r from-gray-100 to-gray-300/80 text-gray-900 min-h-screen'>
                <div>
                    <Navbar />
                </div>
                <main className='flex-grow flex flex-col items-center'>
                    <h1 className="text-center text-3xl font-bold font-serif text-secondary mt-10">BREAKUP TAROT READING</h1>
                    <h2 className="text-lg max-w-4xl mt-2 text-center font-semibold text-secondary">
                        Breakups are tough! Heal some of your heartache from the loss of a love, gain understanding into why the relationship ended, and receive guidance on how to move forward toward a brighter, more fulfilling romantic future.
                    </h2>

                    {/* Cards section */}

                    {/* Pick Two Cards Section */}
                    <div className='text-center mt-10'>
                        <h3 className="text-xl font-bold">PICK TWO CARDS</h3>
                        <p className="text-md mt-2">
                            What does the future have in store for you? Now is the time to discover the day’s possibilities!
                        </p>
                        <div className='flex gap-8 justify-center mt-9'>
                            <div className='w-60 h-96 bg-gray-200 flex items-center justify-center rounded-lg shadow-md cursor-pointer hover:shadow-lg'>
                                {/*First card */}
                                {IsActive1 ?
                                    <img
                                        src={pickedCard1 || breakup} // show picked card or default card if not picked
                                        alt='card1'
                                        className='w-60 h-96 object-cover rounded-md transition-all duration-300 ease-in-out transform ring-4 cursor-pointer ring-black/70 focus:outline-none'
                                        onClick={firstCardClick} /> :
                                    <img
                                        src={breakup} // show default image initially
                                        alt='card1'
                                        className='w-60 h-96 object-cover rounded-md transition-all duration-300 ease-in-out transform ring-4 cursor-pointer ring-black/70 focus:outline-none'
                                        onClick={firstCardClick} />
                                }
                            </div>
                            <div className='w-60 h-96 bg-gray-200 flex items-center justify-center rounded-lg shadow-md cursor-pointer hover:shadow-lg'>
                                {/* Second card */}
                                {IsActive2 ?
                                    <img
                                        src={pickedCard2 || breakup} // show picked card or default card if not picked
                                        alt='card2'
                                        className='w-60 h-96 object-cover rounded-md transition-all duration-300 ease-in-out transform ring-4 cursor-pointer ring-black/70 focus:outline-none'
                                        onClick={secondCardClick} /> :
                                    <img
                                        src={breakup} // show default image initially
                                        alt='card2'
                                        className='w-60 h-96 object-cover rounded-md transition-all duration-300 ease-in-out transform ring-4 cursor-pointer ring-black/70 focus:outline-none'
                                        onClick={secondCardClick} />
                                }
                            </div>
                        </div>
                        <button className="mt-9 bg-secondary text-white py-2 px-16 rounded-lg font-semibold shadow hover:bg-secondary-dark">
                            GET YOUR READING
                        </button>
                    </div>
                    <div className='text-center'>
                        <h2 className="text-2xl font-semibold text-secondary mt-10">
                            About This Reading
                        </h2>
                        <p className="text-lg  max-w-4xl text-gray-700 mt-5">
                            What is the Flirt card, and how does it work? The Flirt card is designed to bring playful energy into your love life, guiding you to embrace the fun and lighthearted aspects of attraction. When you draw this card, it suggests that it's time to focus on the playful, flirtatious side of your interactions, helping you create an inviting and magnetic presence. Whether you're in a new relationship or navigating an exciting crush, the Flirt card encourages you to be bold and enjoy the excitement that comes with building connections.
                        </p>
                        <p className="text-lg max-w-4xl text-gray-700 mt-5">
                            You might wonder: how can a card about flirting influence your approach to love? The answer lies in its energy. Flirting is about setting intentions and vibing with the universe in a way that attracts positive and exciting experiences. The Flirt card’s appearance in your reading is a gentle nudge to lean into the charm and charisma you exude, reminding you to be confident, light-hearted, and enjoy the process of building connection.
                        </p>
                    </div>
                    <div className='flex flex-col w-4/5'>
                        <hr className="border-secondary border-[1.5px] w-full mt-10" />
                        <p className="text-center mt-5">
                            Discover your highest truth with the guidance of a gifted psychic reader.
                        </p>
                        <Link className="text-center">Click here to claim your free reading!</Link>
                        <hr className="border-secondary border-[1.5px]  w-full mt-5 mb-6" />
                    </div>
                    <div className=" flex flex-col ml-4 sm:ml-8 md:ml-16 lg:ml-16 mr-4 sm:mr-8 md:mr-16 lg:mr-16 justify-center items-center">
                        <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary mt-8 font-bold">
                            Recommended Reports For You
                        </h1>

                        {/* Parent Card div */}
                        <div className="flex flex-wrap gap-5 justify-center mt-5">
                            {/* Card 1 */}
                            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                                <div className="flex flex-col items-center">
                                    <img
                                        src={rings}
                                        alt="kundli.png"
                                        className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                    />
                                    <div className="text-center">
                                        <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                                        <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                                            Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                                            chart with others in the database, you can find a person who shares your similarities, characteristics, and
                                            compatible energies.
                                        </p>
                                        <button
                                            onClick={kundliClick}
                                            className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                        >
                                            Match Kundli
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                                <div className="flex flex-col items-center">
                                    <img
                                        src={dailyHoroscope}
                                        alt="daily-horoscope.png"
                                        className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                    />
                                    <div className="text-center">
                                        <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Daily Horoscope</h3>
                                        <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                                            Get your personalized daily horoscope and insights for the day ahead. Stay prepared and make the
                                            most of your day with astrological guidance to navigate challenges, seize opportunities, and align with cosmic energy.
                                        </p>
                                        <button
                                            onClick={horoscopeClick}
                                            className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                        >
                                            View Horoscope
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Card 3 */}
                            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                                <div className="flex flex-col items-center">
                                    <img
                                        src={compatibility}
                                        alt="daily-horoscope.png"
                                        className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                    />
                                    <div className="text-center">
                                        <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Compatibility</h3>
                                        <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-4">
                                            Compatibility helps you understand how well your astrological traits
                                            align with those of another person. By comparing your birth chart with
                                            others in the database, you can find a person who shares your
                                            similarities and characteristics.
                                        </p>
                                        <button
                                            onClick={compatibilityClick}
                                            className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                        >
                                            Check Compatibility
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <div className='mt-6'>
                    <Queryform />
                    <Footer />
                </div>
            </section>
        </>
    );
};

export default BreakupTarot;
